import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { FloatingToolbarButton as ToolbarButton } from '@atlaskit/editor-common/ui';
import FilePreviewIcon from '@atlaskit/icon/glyph/editor/file-preview';
import { messages } from '@atlaskit/media-ui';
import { RenderMediaViewer } from '../ui/MediaViewer/PortalWrapper';
import { getSelectedNearestMediaContainerNodeAttrs } from './utils';
export var FilePreviewItem = function FilePreviewItem(_ref) {
  var mediaPluginState = _ref.mediaPluginState,
    intl = _ref.intl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMediaViewerVisible = _useState2[0],
    setMediaViewerVisible = _useState2[1];
  var openMediaViewer = function openMediaViewer() {
    setMediaViewerVisible(true);
  };
  var onMediaViewerClose = function onMediaViewerClose() {
    setMediaViewerVisible(false);
  };
  var selectedNodeAttrs = getSelectedNearestMediaContainerNodeAttrs(mediaPluginState);
  var shouldRenderMediaViewer = selectedNodeAttrs && mediaPluginState.mediaClientConfig && isMediaViewerVisible;
  var tooltipContent = intl.formatMessage(messages.preview);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToolbarButton, {
    testId: "file-preview-toolbar-button",
    key: "editor.media.card.preview",
    onClick: openMediaViewer,
    icon: /*#__PURE__*/React.createElement(FilePreviewIcon, {
      label: "file preview"
    }),
    tooltipContent: tooltipContent
  }), shouldRenderMediaViewer && /*#__PURE__*/React.createElement(RenderMediaViewer, {
    mediaClientConfig: mediaPluginState.mediaClientConfig,
    onClose: onMediaViewerClose,
    selectedNodeAttrs: selectedNodeAttrs
  }));
};